import React from "react"
import { Section } from "../Components"
import Button from "../Atoms/Button"
import Colors from "../res/styles/Colors"
import { useTranslation } from "react-i18next"
import Lottie from "react-lottie-player"
import { productionflow } from "../res/imgs/lotties"
import Slideshow from "../Atoms/Slideshow"
import { SectionTitle, SectionBody } from "../res/styles/TextStyles"
import styled from "styled-components"
import { breakpointsMax, Col } from "../res/styles/Common"
import { logo_grs, logo_crp, logo_astri } from "../res/imgs/logos"

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.white};
    padding: 30px;
    @media ${breakpointsMax.tablet} {
        padding: 20px;
    }

    a {
        text-decoration: underline;
        color: ${Colors.grey};
    }
`

const Logo = styled.img`
    max-width: 350px;
    width: 100%;
`

function Home() {
    const { t } = useTranslation()

    return (
        <>
            <Container>
                <SectionTitle>{t("home.whoweare")}</SectionTitle>
            </Container>
            <Section
                bg={Colors.white}
                textColor={Colors.grey}
                body={
                    <>
                        <h3>{t("home.title")}</h3>
                        {t("sections.home.first")}
                    </>
                }
            >
                <Slideshow />
            </Section>
            <Section
                bg={Colors.white}
                textColor={Colors.grey}
                body={t("sections.home.second")}
                left
            >
                <Lottie loop={false} animationData={productionflow} play />
            </Section>
            <Container>
                <SectionTitle>{t("home.certifications")}</SectionTitle>
            </Container>
            <Container>
                <Section
                    bg={Colors.white}
                    textColor={Colors.grey}
                    body={
                        <>
                            {t("sections.home.third.first_part")}
                            <a href="http://textileexchange.org/integrity/">
                                {t("sections.home.third.grs_link")}
                            </a>
                            {t("sections.home.third.second_part")}
                            <a href="http://textileexchange.org/about-us/">
                                {t("sections.home.third.textile_link")}
                            </a>
                            {t("sections.home.third.third_part")}
                        </>
                    }
                >
                    <Col align="center">
                        <Logo src={logo_grs} />
                        <SectionBody>
                            {t("sections.home.third.certified_by")} <br />
                            ICEA GR0876
                        </SectionBody>
                    </Col>
                </Section>
            </Container>
            <Container>
                <Section
                    bg={Colors.white}
                    textColor={Colors.grey}
                    body={t("sections.home.crp")}
                >
                    <Col align="center">
                        <Logo src={logo_crp} />
                    </Col>
                </Section>
            </Container>
            <Container>
                <Button
                    big
                    borderColor={Colors.red}
                    textColor={Colors.red}
                    onClick={() =>
                        window.open(
                            `${process.env.PUBLIC_URL}/certification.pdf`
                        )
                    }
                >
                    Download {t("home.certification")}
                </Button>
            </Container>
            <Container>
                <Section
                    bg={Colors.white}
                    textColor={Colors.grey}
                    left
                    body={t("sections.home.fourth")}
                >
                    <Col align="center">
                        <Logo src={logo_astri} />
                    </Col>
                </Section>
            </Container>
        </>
    )
}

export default Home
